export default class {
    static toSqlDateTimeFormat(date) {
        return [
            [date.getFullYear(), date.getMonth() + 1, date.getDate()].join('-'),
            [date.getHours() + 1, date.getMinutes(), date.getSeconds()].join(':')
        ].join(' ');
    }

    /**
     * Checks if the given value is a JavaScript date object.
     *
     * @param date
     * @returns {bool}
     */
    static isValidDate(date) {
        return Object.prototype.toString.call(date) === "[object Date]" && !isNaN(date);
    }

    /**
     * Convert an ISO 8601 date string, e.g. "2019-10-30T13:30:17Z"
     * to a more readable format like "30 Oct 2019, 13:30"
     *
     * @param string
     * @param format
     * @returns {string}
     */
    static formatIsoDateString(string, format = 1) {
        let date = new Date(string);
        let options = {};
        if (typeof(string) !== 'string' || !this.isValidDate(date)) {
            return '';
        }
        switch (format) {
            // e.g. 1 Jan 2020, 00:00
            case 1:
                options = {
                    year: 'numeric',
                    month: 'short',
                    day: '2-digit',
                    hour: '2-digit',
                    minute: '2-digit',
                };
                break;
            // e.g. 1 Jan 2020
            case 2:
                options = {
                    year: 'numeric',
                    month: 'short',
                    day: '2-digit',
                };
                break;
            // e.g. Wed, 1 Jan 2020
            case 3:
                options = {
                    year: 'numeric',
                    month: 'short',
                    day: 'numeric',
                    weekday: 'short',
                };
                break;
            // e.g. 01/02/2020
            case 4:
                options = {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit'
                }
        }

        return date.toLocaleDateString('en-gb', options);
    }

    /**
     * Convert an ISO 8601 date string, e.g. "2019-10-30T13:30:17Z"
     * to a more readable time format like "13:30:00"
     *
     * @param string
     * @param format
     * @param locale
     * @returns {string}
     */
    static formatLocaleTimeString(string, format = 1, locale = 'en-GB', timezone = 'UTC') {
        let date = new Date(string);
        let options = {};
        if (typeof(string) !== 'string' || !this.isValidDate(date)) {
            return '';
        }
        switch (format) {
            // hh:mm:ss
            case 1:
                options = {
                    hour: '2-digit',
                    minute: '2-digit',
                    second: '2-digit',
                }

        }

        options.timezone = timezone;

        return new Intl.DateTimeFormat(locale, options).format(date);
    }



    /**
     * @param date
     * @returns {string}
     */
    static toIsoDate(date) {
        if (typeof date.getYear !== 'function') {
            return date;
        }

        return date.toISOString().split('T')[0];
    }

    static toSqlDateFormat(date) {
        return [date.getFullYear(), date.getMonth() + 1, date.getDate()].join('-')
    }

    /**
     * Calculates a person's age in years.
     *
     * @param dateOrString
     * @param atDate Can be used to override the today date to get an age at a specific date
     * @returns {Number}
     */
    static calculateAge(dateOrString, atDate = null) {
        let date = (this.isValidDate(dateOrString)) ? dateOrString : new Date(dateOrString);

        let today;
        if (atDate) {
            today = (this.isValidDate(dateOrString)) ? atDate : new Date(atDate);
        } else {
            today = new Date();
        }

        let age = today.getFullYear() - date.getFullYear();
        let m = today.getMonth() - date.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < date.getDate())) {
            age--;
        }
        return age;
    }

    /**
     * @param dateOfBirth
     * @returns {{month: null, year: null, day: null}|{month: *, year: *, day: *}}
     */
    static setDateOfBirthObject(dateOfBirth) {
        if (dateOfBirth !== null && typeof dateOfBirth === 'string') {
            let customerDob = dateOfBirth.split(' ')[0].split('-');
            return {
                day: customerDob[2],
                month: customerDob[1],
                year: customerDob[0],
            };
        } else if (dateOfBirth instanceof Object) {
            if (dateOfBirth.hasOwnProperty('day') && dateOfBirth.hasOwnProperty('month') && dateOfBirth.hasOwnProperty('year')) {
                return dateOfBirth;
            }
        }

        return {
            day: null,
            month: null,
            year: null,
        }
    }

    static unixTimestamp() {
        return Math.round(((new Date).getTime())/1000);
    }
}
